//@flow
import React, { Component } from 'react';
import { renderers } from 'react-virtualized-tree';

import type { DirSvcNode } from 'state/types/dirSvcTypes';
import { isNodeGroup, isNodeUser } from 'util/dirSvcUtils';

const { Expandable } = renderers;

type TreeNodeProps = {
  onChange: Function,
  node: DirSvcNode,
  queryDirectoryServiceCommand: Function,
  selectedNode?: DirSvcNode,
  setSelectedNode: (?DirSvcNode) => void,
};

export default class SourceNode extends Component<TreeNodeProps> {
  handleClickNode: Function;
  getNodeIcon: Function;

  constructor() {
    super();
    this.handleClickNode = this.handleClickNode.bind(this);
    this.getNodeIcon = this.getNodeIcon.bind(this);
  }

  handleClickNode() {
    const { node, setSelectedNode } = this.props;
    setSelectedNode(node);
    if (isNodeGroup(node)) {
      this.props.queryDirectoryServiceCommand();
    }
  }

  getNodeIcon(node: DirSvcNode) {
    if (isNodeUser(node)) {
      return 'fa fa-user';
    } else if (isNodeGroup(node)) {
      return 'fa fa-users';
    } else {
      return 'fa fa-circle';
    }
  }

  render() {
    const { onChange, node, selectedNode } = this.props;
    const className =
      selectedNode && selectedNode.id === node.id
        ? 'pseudo-table-row-selected'
        : '';
    return (
      <div
        className={`has-pointer ${className}`}
        onClick={this.handleClickNode}
        style={{ padding: '4px 8px' }}
        data-test-name="mapping-source-item"
      >
        <Expandable
          iconsClassNameMap={{
            expanded: 'fa fa-folder-open',
            collapsed: 'fa fa-folder',
            lastChild: this.getNodeIcon(node),
          }}
          node={node}
          onChange={onChange}
        >
          <span style={{ padding: '6px' }}>{node.attributes.name}</span>
        </Expandable>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/Pages/DirectoryServicesPage/SourceNode.js